import React, { useRef, useEffect, useState } from "react";
import "./ProductGallery.css";
import rightArrow from "../Assets/right_arrow.webp";
import leftArrow from "../Assets/left_arrow.webp";

const allowedCategories = [
  "Gems",
  "Rajasthani Puppets",
  "Jaipur Carpets",
  "Jaipur Juttis",
  "Lac Bangles",
  "Rajasthani Paintings",
  "Sanganeri & Bagru Print",
  "Rajasthani Folk Jewellery",
  "Metal Crafts",
  "Gems & Jewellery",
];

const ProductGallery = () => {
  const scrollRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch('https://jaipurmasale-backend.onrender.com/api/house-of-garv/product-category/');
        if (!response.ok) {
          throw new Error('Failed to fetch product categories.');
        }
        const data = await response.json();
        // Filter only allowed categories
        const filtered = data.data.filter(cat => allowedCategories.includes(cat.name));
        setCategories(filtered);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft } = scrollRef.current;
      const scrollAmount = 250;
      scrollRef.current.scrollTo({
        left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  if (loading) {
    return <div className="shopby-horizontal-wrapper"><div>Loading...</div></div>;
  }
  if (error) {
    return <div className="shopby-horizontal-wrapper"><div className="text-red-500">{error}</div></div>;
  }

  return (
    <div className="shopby-horizontal-wrapper">
      <div className="shopby-horizontal-scroll-container">
        {/* Removed left and right arrow buttons for native scroll */}
        <div className="shopby-horizontal-list" ref={scrollRef}>
          {categories.map((cat) => (
            <a
              key={cat.id || cat.name}
              href={cat.navigate_link}
              className="shopby-category-item"
              tabIndex={0}
            >
              <div className="shopby-category-img-wrapper">
                <img src={cat.media} alt={cat.name} className="shopby-category-img" loading="lazy" />
              </div>
              <div className="shopby-category-label">{cat.name}</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductGallery;
